import { render, staticRenderFns } from "./EditDropdownDocsType.vue?vue&type=template&id=23e4f8b6&"
import script from "./EditDropdownDocsType.vue?vue&type=script&lang=js&"
export * from "./EditDropdownDocsType.vue?vue&type=script&lang=js&"
import style0 from "./EditDropdownDocsType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports